import { createApp } from 'vue';
import './assets/main.css';
import { setupGlobalMethods } from '@/plugins';
import App from './App.vue';
import { setupRouter } from '@/router';
import { setupStore } from '@/stores';
import 'amfe-flexible'


async function bootstrap() {
    
    const app = createApp(App);
    
  
    // 挂载状态管理
    setupStore(app);
  
    
    // 注册全局自定义组件
    //setupCustomComponents();
  
    // 注册全局自定义指令，如：v-permission权限指令
    setupGlobalMethods(app)


    // 路由准备就绪后挂载 APP 实例
    // https://router.vuejs.org/api/interfaces/router.html#isready
    await setupRouter(app);
    console.log('开始')
  
    app.mount('#app', true);
}

bootstrap();


